import { render, staticRenderFns } from "./PurchaseMoreBtn.vue?vue&type=template&id=53a978a2&"
import script from "./PurchaseMoreBtn.vue?vue&type=script&lang=ts&"
export * from "./PurchaseMoreBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign({QBtnGroup,QBtn,QIcon}, component.options.components || {})
